import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import LayoutSidebarContainer from "@/layouts/sidebar/src/LayoutSidebarContainer.vue";
import LayoutSidebarBody from "@/layouts/sidebar/src/LayoutSidebarBody.vue";
import LayoutSidebarSidebar from "@/layouts/sidebar/src/LayoutSidebarSidebar.vue";
import LayoutSidebarCta from "@/layouts/sidebar/src/LayoutSidebarCta.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutSidebar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(LayoutSidebarContainer, null, {
      default: _withCtx(() => [
        _createVNode(LayoutSidebarSidebar),
        _createVNode(LayoutSidebarBody, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(LayoutSidebarCta)
  ]))
}
}

})